// extracted by mini-css-extract-plugin
export default {"page":"eRn33C4Xxgw0DNTK8urO","content":"__hFLfM5Lcd977E8IY1V","fade-in":"Lckw0YpEFnBL2abBAs5j"};